import { gql } from "@apollo/client";

export const MUTATION_REPORT_PROBLEM = gql`
  mutation Mutation($name: String!, $phoneNumber: String!, $description: String!) {
    reportProblem(name: $name, phoneNumber: $phoneNumber, description: $description) {
      message
      data {
        id
      }
    }
  }
`;
